const AbstractRepository = require('@/lib/Repositories/AbstractRepository');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const OptionSet = require('@/lib/ItemOptions/OptionSet');
const { createModelBasicHydrator } = require('@/lib/Hydration/basicHydrator');

class OptionSetRepository extends AbstractRepository {
    /**
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     * @param {ApiClient} apiClient
     */
    constructor(
        dataStore,
        hydrator,
        syncStateManager,
        apiClient,
    ) {
        super(dataStore, hydrator, syncStateManager);

        this.apiClient = apiClient;
    }

    getEntityClass() {
        return OptionSet;
    }

    getEntityName() {
        return 'Option Set';
    }

    getTableName() {
        return DataStoreNames.OPTION_SETS;
    }

    loadFromApi(branchID = null) {
        return this.apiClient
            .request(
                'GET',
                'optionsets',
                {
                    branchID, // Send the requested branchID to the API so it is used instead of any default.
                }
            )
            .then(({ data }) => {
                return this.hydrateModelsFromApi(data);
            });
    }

    /**
     * @returns {Promise<OptionSet[]>}
     */
    findAllActive() {
        return super._findAllActive();
    }

    /**
     * @param {number} itemID
     *
     * @returns {Promise<OptionSet[]>}
     */
    findActiveForItem(itemID) {
        return this.dataStore
            .getStore(this.getTableName())
            // itemIDs is a MultiEntry index:
            // https://github.com/dexie/Dexie.js/issues/871#issuecomment-513874791
            // https://dexie.org/docs/MultiEntry-Index
            .where({ itemIDs: itemID, status: 'Active' })
            .toArray()
            .then(createModelBasicHydrator(this.getEntityClass()));
    }

    clearDataBeforeInserting() {
        // Keep data from other branches when syncing for a new branch.
        return false;
    }
}

module.exports = OptionSetRepository;
